import { Fragment, useContext, useEffect, useState } from "react";
import Loader from "../../Components/Loader";
import dayjs from 'dayjs';
import TokenService from "../../Services/Token.service";
import { DonorService } from "../../Services/Donor.Service";
import { AdminService } from "../../Services/Admin.service";
import SampleTypeDropdown from "../../Components/AdministrativeSettings/SampleTypeDropdown";
  import DateRangeFilter from "../../Components/AdministrativeSettings/DateRangeFilter";
import TablePagination from "../../Components/AdministrativeSettings/TablePagination";
import Toaster from "../../Components/Toaster";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import JobDetailsAcceptPopup from "./JobDetailsAcceptPopup";
import { Field } from "formik";
import { GlobalInfo } from "../../Contexts/GlobalContext";
import { formatDate, formatTime } from "../../Utils/Common";
import { Helmet } from "react-helmet";
import { SampleService } from "../../Services/Sample.service";
 
import { DatePicker } from "antd";
 
import { Dropdown } from "react-bootstrap";

const { RangePicker } = DatePicker;

function JobList(props) {

    const { userDetails } = useContext(GlobalInfo);
    const [showJobDetailsAcceptModal, setShowJobDetailsAcceptModal] = useState(false);

    const handleShowJobDetailsAcceptModal = () => setShowJobDetailsAcceptModal(true);
    const handleCloseJobDetailsAcceptModal = () => setShowJobDetailsAcceptModal(false);


    const confirmPickupModal = (values) => {   
        handleJobDetailsAcceptModalConfirm(values.id, values);
        handleCloseJobDetailsAcceptModal();
    };

    const handleJobDetailsAcceptModalConfirm = async (jobId, values) => {
        if(jobId){

        setLoading(true);
        try {
            const payload = {
                interval_id: jobId,
                request_id: viewJob.request_id,
                donor_id: TokenService.getUserId(),
                is_matched : viewJob.matched_sample,

                ...(viewJob?.matched_sample === "no" && { 
                    sample_id: viewJob.sample_ids 
                }),

                // ...(viewJob?.matched_sample === "no" && { 
                //     sample_id: Array.isArray(viewJob.sample_ids) 
                //         ? Number(viewJob.sample_ids[0]) 
                //         : Number(viewJob.sample_ids),
                // }),
                // sample_id : viewJob.sample_ids,

                appointment_time : viewJob.time_interval,
                appointment_date : viewJob.sample_pickup_date,
                price: viewJob.total_sample_cost,
                // general_requirement : values.acceptGeneralRequirements && values.acceptJob ? 'yes' : 'no',
                general_requirement : values.acceptGeneralRequirements && values.acceptCompensationDependency &&  values.filledConcentForm && values.healthQuestionnaire ? 'yes' : 'no',

                // acceptGeneralRequirements: values.acceptGeneralRequirements,
                // acceptJob: values.acceptJob,
            }
            
            //api doesnt exists yet
            const response = await DonorService.acceptJob(payload);

            if (response.success) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Job accepted successfully:", response);
                fetchJobList();
                setLoading(false);
                onUpdateDonations();
                // fetchSampleTypeList();
            } else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) {            
            console.error("Failed to accept job:", error);
            setToastMessage(  error.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
    }
    else{
        setToastMessage("Jobs details are not correctly loaded.");
        setShowToast(true);
        setToastVariant('error'); 
    }
    };



    const [samples, setSamples] = useState([]);

    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalJobList, setTotalJobs] = useState(0);
    const [jobList, setJobList] = useState([]);
    const [selectedSamples, setSelectedSamples] = useState([]);
    const [selectedCompesationSort, setSelectedCompesationSort] = useState("");

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);


    const { isClearFilter } = props;
    const { onFilterCountChange } = props;

    const { type } = props;
    const {onUpdateDonations} = props;


    const [selectedJob, setSelectedJob] = useState(null); // Track selected radio button
    const [errorMessage, setErrorMessage] = useState(""); // Track error message
    const [viewJobId, setViewJobId] = useState(null);
    const [viewJob, setViewJob] = useState(null);
    const handleRadioChange = (job) => { 
        setSelectedJob(job); // Update selected job
        setErrorMessage(""); // Clear error message
    };


    const handleViewDetails = (jobId, job) => {        
        setViewJobId(jobId); // Set the current job's ID for error message tracking
        setViewJob(job);
     
        if (`${job?.request_id}-${job?.matched_sample === 'yes' ? 'matched' : job?.sample_ids }` !== jobId) {
            setErrorMessage("Please select a time to view the details.");
        } else {
            setErrorMessage(""); // Clear error if the correct radio button is selected
            handleShowJobDetailsAcceptModal();
        }
    };

    useEffect(() => {
        if (isClearFilter) {
            setSelectedSamples([]);
            setSelectedCompesationSort("");
            onFilterCountChange(0);
            setSelectedDateRange([null, null]);
        }
    }, [isClearFilter]);

    // Calculate and update the filter count
    useEffect(() => {
        const count = [
            selectedSamples.length > 0 ? 1 : 0,
            selectedCompesationSort ? 1 : 0,
            selectedDateRange[0] && selectedDateRange[0] != null ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [selectedSamples, selectedCompesationSort, selectedDateRange]);


    useEffect(() => {
        fetchSampleTypes();
    }, []);

    useEffect(() => {
        fetchJobList();
    }, [pagination, selectedSamples, selectedCompesationSort]);
    //   selectedRoles, searchEmail, searchPhone, searchId

    function fetchJobList() {
        setLoading(true);

        const userId = TokenService.getUserId();
        const filters = {
            samples: selectedSamples.map((sample) => Number(sample)),
            from_date: selectedDateRange[0],
            to_date: selectedDateRange[1],
            price: selectedCompesationSort,//htl or lth
        };
        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            donor_id: userId,
            filters: filters,
        };
        DonorService.getJobsList(params)
            .then((response) => {
                // setJobList(response.data.list);
                // setTotalJobs(response.data.total)

                const jobs = response.jobs.list;
                const groupedJobs = groupJobsByRequestAndSample(jobs);

                setJobList(groupedJobs); // Store grouped jobs in state
                // setJobList(response.jobs.list);
                setTotalJobs(response.jobs.total_jobs);

                setLoading(false);
            })
            .catch((error) => {
                console.error("Failed to fetch sample request list", error);
                setLoading(false);
            });

    }
    async function fetchSampleTypes() {
        AdminService.getSampleTypes()
            .then((sampleTypes) => {
                setSamples(sampleTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch sample types", error);
            });
    }

    const handleSampleChange = (sample) => {
        if (selectedSamples.includes(sample)) {
            setSelectedSamples(selectedSamples.filter((s) => s !== sample));
        } else {
            setSelectedSamples([...selectedSamples, sample]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleCompensationChange = (compensation) => {
        // setSelectedCompesationSort(compensation.target.value);
        setSelectedCompesationSort(compensation);
    }
    const handleDateRangeChange = (daterange) => {

        if (daterange[0] && daterange[1]) {
            // const startDate = dayjs(daterange[0]).startOf('day').toDate();
            // const endDate = dayjs(daterange[1]).endOf('day').toDate();
            const startDate = daterange[0];
            const endDate = daterange[1];

            const dateRangee = [startDate, endDate];

            // Set the selected date range to the adjusted date array
            setSelectedDateRange(dateRangee);

            // Reset pagination whenever the date range changes
            setPagination({ ...pagination, page: 1, offset: 0 });
        }else{
            setSelectedDateRange([null,null]);
        }

    };



    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalJobList);
            setPagination({ limit: totalJobList, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = jobList.length;  //ex 10 
    const totalPages = Math.ceil(totalJobList / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };
    
    function groupJobsByRequestAndSample(jobs) {
        const groupedJobs = {};

        jobs.forEach((job) => {
            if (job.matched_sample === "no") {
                const key = `${job.request_id}-${job.sample_ids}`; // Unique key for grouping
                if (!groupedJobs[key]) {
                    groupedJobs[key] = [];
                }
                groupedJobs[key].push(job);
            } else {
                // Directly add matched_sample === "yes" to groupedJobs without grouping
                const key = `${job.request_id}-matched`;
                if (!groupedJobs[key]) {
                    groupedJobs[key] = [];
                }
                groupedJobs[key].push(job);
            }
        });

        return groupedJobs;
    }

    return ( 
        <>
            <Helmet>
                <title>DonorX | Job Board</title>
            </Helmet>
            <div className="">
                <Loader loading={loading} />
                <div className="d-flex mt-3 mb-3 col-md-8">
                    <div className="ms-2 jb-filter-date jb-filters">
                        <div className="job-list-st-filter el-board-table p-0 m-0">
                            <DateRangeFilter
                                selectedDateRange={selectedDateRange}
                                handleDateRangeChange={handleDateRangeChange}
                                setSelectedDateRange={setSelectedDateRange}
                                label={"Date"}
                                type={"jobBoard"} />
                        </div> 
                    </div>
                    <div className="ms-2 jb-filters el-board-table p-0 m-0"> 
                        <div className="job-list-st-filter">
                            <SampleTypeDropdown
                                samples={samples}
                                selectedSamples={selectedSamples}
                                handleSampleChange={handleSampleChange}
                                setSelectedSamples={setSelectedSamples} type={"jobBoard"} />
                        </div> 
                    </div>
                    <div className="ms-2 jb-filters">
                        <Dropdown onSelect={handleCompensationChange}>
                        <Dropdown.Toggle variant="secondary" className="navbar-drop-buttons" id="dropdown-basic">
                            {selectedCompesationSort ? (selectedCompesationSort === "asc" ? "Low To High" : "High To Low") : "Compensation"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="el-admin">
                            <Dropdown.Item eventKey="asc">Low To High</Dropdown.Item>
                            <Dropdown.Item eventKey="desc">High To Low</Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>

                        {/* <select name="compensation" value={selectedCompesationSort} onChange={handleCompensationChange} className="form-control" id="compensation">
                            <option value="" disabled>Compensation</option>
                            <option value="asc">Low To High</option>
                            <option value="desc">High To Low</option>
                        </select> */}
                    </div>
                </div>
                {Object.entries(jobList).length > 0  ? (
                    <>
                        {Object.entries(jobList).map(([groupKey, jobs]) => (
                        <>
                            <div className="el-bg-table" style={{ border: '1px solid lightgrey' }}>
                                <Fragment key={groupKey}>
                                    <div>
                                        <h5 className="text-center">
                                            {/* Request ID: {jobs[0].request_id}, Sample Type: {jobs[0].sample_names} */}
                                        </h5>
                                        {jobs.map((job, index) => (
                                            <>
                                                <div key={job.interval_id}>
                                                    <div className="row align-items-center">
                                                        <div className="col-12 col-md-1 d-flex justify-content-center mb-2 mb-md-0">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input"
                                                                name="jobSelection"
                                                                value={job.request_id}
                                                                id={`job-${job.interval_id}-${index}`}
                                                                onChange={() => handleRadioChange(job)}
                                                            />
                                                            <label htmlFor={`job-${job.interval_id}-${index}`} className="ms-2"></label>
                                                        </div>

                                                        <div className="col-12 col-md-3 mb-2 mb-md-0 text-center text-md-start">
                                                            {formatDate(job.sample_pickup_date)}
                                                        </div>

                                                        <div className="col-12 col-md-2 mb-2 mb-md-0 text-center text-md-start">
                                                            {formatTime(job.time_interval)}
                                                        </div>

                                                        <div className="col-12 col-md-3 mb-2 mb-md-0 text-center text-md-start">
                                                            {job.lab_name}
                                                        </div>

                                                        <div className="col-12 col-md-2 mb-2 mb-md-0 text-center text-md-start">
                                                            <SampleType sampletype={job.sample_ids} sampletypes={samples} />
                                                        </div>

                                                        <div className="col-12 col-md-1 mb-2 mb-md-0 text-center text-md-start">
                                                            ${job.total_sample_cost}
                                                        </div>
                                                    </div>
                                                </div>
                                                {index < jobs.length - 1 && (
                                                    <div style={{ textAlign: 'center', margin: '10px 0', color: 'lightgrey' }}>
                                                        <hr />
                                                    </div>
                                                )}
                                                {/* <div style={{ textAlign: 'center', margin: '10px 0', color: 'lightgrey' }}>
                                                    <hr />
                                                </div> */}

                                            </>
                                        ))}
                                    </div>
                                </Fragment>
                            </div>
                            <div className="text-center mt-4">
                                <button className="el-main-button" onClick={() => handleViewDetails(groupKey, selectedJob)}><span>View Job Details</span></button>
                            </div>

                            <div
                                className="text-danger"
                                style={{ visibility: errorMessage && viewJobId === groupKey ? "visible" : "hidden", height: "1.5em", }} >
                                {viewJobId === groupKey ? errorMessage : ""}
                            </div>
                        </>
                        ))}
                    </>
                ) : <div><h6>There are no jobs available. Check back again soon.</h6></div> }

                
            </div>

            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
            {/* {showJobDetailsAcceptModal && ( */}
                <> 
                    <JobDetailsAcceptPopup
                        show={showJobDetailsAcceptModal}
                        showModal={handleShowJobDetailsAcceptModal}
                        onHide={handleCloseJobDetailsAcceptModal}
                        onConfirm={confirmPickupModal}
                        jobNumber={selectedJob?.request_id}
                        job={viewJob}
                    />
                </>
            {/* )} */}
        </>
    );
}

export default JobList

function SampleType({ sampletype, sampletypes }) {
    const sampleIds = sampletype ? sampletype?.split(',').map(id => id.trim()) : [];

    return (<>

        <div className="el-icons-bg-box">
            {sampleIds?.length > 0 ? (
                sampleIds?.map((sampleId) => {
                    const sampleType = sampletypes?.find((type) => type.id === sampleId);
                    return sampleType ? (

                        <Fragment key={sampleId}>
                            {sampleIds?.length == 1 ? (<><div className={`btn bg-${sampleType.divClass} el-sample-btn `} key={sampleType.interval_id}><i className={sampleType.className}></i> {sampleType.label}</div> </>) : (<><OverlayTrigger
                                key={sampleId}
                                placement="top"
                                overlay={
                                    <Popover id={`popover-${sampleId}`}>
                                        <Popover.Header as="h3">{sampleType.label}</Popover.Header>
                                    </Popover>
                                }
                            >                                
                                <Button variant="outlined-secondary" className={sampleType.buttonClass}>
                                    <i className={sampleType.className}></i>
                                </Button>
                            </OverlayTrigger>
                            </>)}


                        </Fragment>
                    ) : null;
                })
            ) : (
                "No samples available"
            )}
        </div>
    </>);
}

 